import { create } from 'twind'
import { domSheet } from 'twind/sheets'
import {
  useState,
  useEffect,
  useContext,
  ReactElement,
  createContext,
} from 'react'

const TWContext = createContext<ReturnType<typeof create>>(null)

type Props = {
  sheet: HTMLStyleElement
  children: ReactElement
  settings: Omit<Parameters<typeof create>[0], 'sheet'>
}

export function useTw() {
  return useContext(TWContext).tw
}

export function Styles({ sheet, children, settings }: Props) {
  const [set, setSet] = useState(false)
  const [tw, setTw] = useState<ReturnType<typeof create>>(null)
  useEffect(() => {
    setTw(create({ ...settings, sheet: domSheet({ target: sheet }) }))

    setSet(true)
  }, [settings, sheet])

  return set ? (
    <TWContext.Provider value={tw}>{children}</TWContext.Provider>
  ) : null
}
